import Vue from 'vue'
import Router from 'vue-router'

import Dome from './router-child/dome'                          // dome类
import enterInfo from './router-child/enterInfo'                // enterInfo类
import TaskList from './router-child/task-list'                 // 任务列表
import PersonalCenter from './router-child/personal-center'     // 个人中心
import orderAbout from './router-child/orderAbout'              // 订单相关
import Index from './router-child/index'                        // 首页
import Team from './router-child/team'                          // 团队
import Test from './router-child/bloom-test'                    // bloom的考卷和练习Invigilate
import proctor from './router-child/bloom-proctor'        // bloom监考
import wonderfulMoment from './router-child/wonderful-moment'   // 精彩瞬间列表
import Planet from './router-child/planet'                      // bloom的考卷和练习
import SuperQuiz from './router-child/super-quiz'               // SuperQuiz春节考试
import ThirdPart from './router-child/thirdpart'                // 第三方签订协议
import WxLanding from './router-child/wechat'                   // 微信登录落地页
import BloomLive from './router-child/bloom-live'               // 直播间
import EventPlaza from './router-child/event-plaza'             // 活动广场
import Society from './router-child/society'                    // 俱乐部相关
import Discover from './router-child/discover'                  // 发现
import Advertisment from './router-child/advertisement'         // 广告相关
import Questionnaire from './router-child/questionnaire'        // 问卷调查
import BloomRoom from './router-child/bloom-room'               // 房间
import BattleCenter from  './router-child/battleCenter'         // 极速抢答
import NotFound from './router-child/not-found'                 // 必须放到最下面这个是404一类页面
import studentCertification from './router-child/sub-task/studentCertification'
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

export default new Router({
  routes: [
    ...Index,            // 首页
    ...Dome,             // dome类
    ...enterInfo,
    ...PersonalCenter,   // 个人中心
    ...TaskList,         // 任务列表
    ...orderAbout,       // 订单相关
    ...Team,             // 团队
    ...Planet,           // 成长星球
    ...Test,             // bloom的考卷和练习
    ...proctor,
    ...wonderfulMoment,  // 精彩瞬间列表
    ...SuperQuiz,        // SuperQuiz春节考试
    ...ThirdPart,        // 第三方签订协议
    ...WxLanding,        // 微信登录落地页
    ...BloomLive,        // 直播间
    ...EventPlaza,       // 活动广场
    ...Society,          // 俱乐部相关
    ...Discover,
    ...studentCertification,     // 学生认证
    ...Advertisment,     // 广告相关
    ...Questionnaire,    // 问卷调查
    ...BloomRoom,        // 房间
    ...BattleCenter,     // 极速抢答
    ...NotFound          // 必须放到最下面这个是404一类页面
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js